import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { ClaimService } from '../../claim.service';
import { AdvancedSearch } from '../../model/advanced-search.model';
import { Observable } from 'rxjs/Observable';
import { CrawfordSnackbarService } from 'crawford-shell';

@Injectable()
export class ExportGuardService implements CanActivate {
  constructor(
    private claimService: ClaimService,
    private snackbarService: CrawfordSnackbarService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const savedSearch = this.claimService.loadSearch();

    if (savedSearch && savedSearch instanceof AdvancedSearch) {
      return true;
    } else {
      this.snackbarService.displayInfoMessage('No search results available to export.  Please perform a new search.');
      this.router.navigate(['/claim/search']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim-export/guard/export-guard.service.ts